import { render } from "./App.vue?vue&type=template&id=5d55b310&bindings={\"gang\":\"setup\",\"games\":\"setup\",\"mostWanted\":\"setup\",\"standings\":\"setup\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script